import { Shield } from "lucide-react";
import { Button } from "@radix-ui/themes";
import { useAuth } from "@/providers/AuthProvider";

interface UnauthorizedProps {
  message?: string;
  showHomeButton?: boolean;
}

export function Unauthorized({
  message = "You don't have permission to access this page.",
  showHomeButton = false,
}: UnauthorizedProps) {
  const { safeNavigate } = useAuth();

  return (
    <div className="flex flex-col items-center justify-center p-8 w-full h-full min-h-[400px]">
      <div className="max-w-md w-full text-center">
        <div className="flex justify-center mb-5">
          <div className="rounded-full bg-gray-100 dark:bg-gray-800 p-3">
            <Shield className="h-8 w-8 text-gray-500 dark:text-gray-400" />
          </div>
        </div>

        <h2 className="text-xl font-medium mb-3 text-gray-700 dark:text-gray-300">
          Access Denied
        </h2>

        <p className="text-gray-500 dark:text-gray-400 mb-6">{message}</p>

        {showHomeButton && (
          <Button
            variant="outline"
            onClick={() => safeNavigate("/")}
            size="1"
            className="mx-auto"
          >
            Return to Home
          </Button>
        )}
      </div>
    </div>
  );
}
